import AbstractApiModule from '../../AbstractApiModule';
import { getAuthConfig } from '../../../utils/getAuthConfig';

const urlFactory = {
  sendApplication: '/v2/internal/friends/application/',

  getFriendsPage : '/v2/internal/friends/batch/main-page/',
  getDictionary  : '/v2/internal/friends/dictionary/',
  raffles        : '/v2/internal/friends/raffles/',
  getAdvantages  : '/v2/internal/friends/advantages/',
  reviews        : '/v2/internal/friends/reviews/',

  draftStories       : '/v2/internal/friends/stories/active_draft/',
  createStories      : '/v2/internal/friends/stories/',
  addFilesStory      : (id) => `/v2/internal/friends/stories/detail/${id}/files/`,
  deleteFilesToStory : (storyId, fileId) => `/v2/internal/friends/stories/detail/${storyId}/files/${fileId}/`,
  publishStory       : (storyId) => `/v2/internal/friends/stories/detail/${storyId}/publish/`,
  updateStory        : (storyId) => `/v2/internal/friends/stories/detail/${storyId}/`
};

export default class FriendsModule extends AbstractApiModule {
  constructor(options) {
    super(options);
    this.apiURL = options.apiURL;
  }

  getDictionary() {
    return new Promise((resolve, reject) => {
      this.get(urlFactory.getDictionary).then(({ data }) => {
        resolve(data.data);
      }).catch(({ response : { data } }) => {
        reject(data);
      });
    });
  }

  sendApplication(params = {}) {
    return new Promise((resolve, reject) => {
      this.post(urlFactory.sendApplication, params, getAuthConfig()).then(({ data }) => {
        resolve(data);
      }).catch(({ response : { data } }) => {
        reject(data);
      });
    });
  }

  getFriendsPage() {
    return new Promise((resolve, reject) => {
      this.get(urlFactory.getFriendsPage).then(({ data }) => {
        if (data) {
          resolve({
            dictionary : data[`/api${urlFactory.getDictionary}`],
            raffles    : data[`/api${urlFactory.raffles}`],
            advantages : data[`/api${urlFactory.getAdvantages}`],
            reviews    : data[`/api${urlFactory.reviews}`]
          });
        }
      }).catch(({ response : { data } }) => {
        reject(data);
      });
    });
  }

  getAdvantages() {
    return new Promise((resolve, reject) => {
      this.get(urlFactory.getAdvantages).then(({ data }) => {
        resolve(data.data);
      }).catch(({ response : { data } }) => {
        reject(data);
      });
    });
  }

  getRaffles() {
    return new Promise((resolve, reject) => {
      this.get(urlFactory.raffles).then(({ data }) => {
        resolve(data.data);
      }).catch(({ response : { data } }) => {
        reject(data);
      });
    });
  }

  getReviews() {
    return new Promise((resolve, reject) => {
      this.get(urlFactory.reviews).then(({ data }) => {
        resolve(data.data);
      }).catch(({ response : { data } }) => {
        reject(data);
      });
    });
  }

  addReview(params = {}) {
    return new Promise((resolve, reject) => {
      this.post(urlFactory.reviews, params, getAuthConfig()).then(({ data }) => {
        resolve(data);
      }).catch(({ response : { data } }) => {
        reject(data);
      });
    });
  }

  getDraftStories() {
    return new Promise((resolve, reject) => {
      this.get(urlFactory.draftStories).then(({ data }) => {
        resolve(data.data);
      }).catch(({ response : { data } }) => {
        reject(data);
      });
    });
  }

  createDraftStories() {
    return new Promise((resolve, reject) => {
      this.post(urlFactory.createStories, {}, getAuthConfig()).then(({ data }) => {
        if (data && data.data) {
          resolve(data.data);
        } else {
          reject(data);
        }
      }).catch(({ response : { data } }) => {
        reject(data);
      });
    });
  }

  addFilesStory(id, params) {
    return new Promise((resolve, reject) => {
      this.post(urlFactory.addFilesStory(id), params, getAuthConfig()).then(({ data }) => {
        if (data && data.data) {
          resolve(data.data);
        } else {
          reject(data);
        }
      }).catch(({ response : { data } }) => {
        reject(data);
      });
    });
  }

  deleteFilesToStory(storyId, fileId) {
    return new Promise((resolve, reject) => {
      this.delete(urlFactory.deleteFilesToStory(storyId, fileId), {}, getAuthConfig()).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          reject(data);
        }
      }).catch(({ response : { data } }) => {
        reject(data);
      });
    });
  }

  publishStory(storyId) {
    return new Promise((resolve, reject) => {
      this.post(urlFactory.publishStory(storyId), {}, getAuthConfig()).then(({ data }) => {
        if (data && data.data) {
          resolve(data.data);
        } else {
          reject(data);
        }
      }).catch(({ response : { data } }) => {
        reject(data);
      });
    });
  }

  updateStory(storyId, params) {
    return new Promise((resolve, reject) => {
      this.put(urlFactory.updateStory(storyId), params, getAuthConfig()).then(({ data }) => {
        if (data && data.data) {
          resolve(data.data);
        } else {
          reject(data);
        }
      }).catch(({ response : { data } }) => {
        reject(data);
      });
    });
  }
}
